import { Component, OnInit, Input } from "@angular/core";
import { LayoutService } from "app/shared/services/layout.service";

@Component({
  selector: "app-sidenav",
  templateUrl: "./sidenav.component.html"
})
export class SidenavComponent {
  @Input("items")
  public menuItems: any[] = [];
  @Input("hasIconMenu")
  public hasIconTypeMenuItem: boolean;
  @Input("iconMenuTitle")
  public iconTypeMenuTitle: string;
  public layoutConf: any;

  constructor(private layout: LayoutService) {}
  ngOnInit() {
    this.layoutConf = this.layout.layoutConf;
  }


  scrollTo(selector: string) {
    if(document) {
      let element = <HTMLElement>document.querySelector(selector);
      element.scrollIntoView({ behavior: 'smooth' });
      this.toggleSidenav();
    }
  }

  toggleSidenav() {
    if (this.layoutConf.sidebarStyle === "closed") {
      return this.layout.publishLayoutChange({
        sidebarStyle: "full"
      });
    }
    this.layout.publishLayoutChange({
      sidebarStyle: "closed"
    });
  }
}
